var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"max-width",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('ad-detail-vue',{attrs:{"ad":_vm.ad}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }